import React from "react";

const Line = (props) => {
  return <div className={props.type}></div>;
};

export default Line;
